module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_3-a50d775592761a0178125fc041d9e313.webp";